export const TITLE = 'Multa Cobrada dos Devedores';
export const TAXAS_JUROS = 'Taxa de Juros';
export const TAXAS_MULTA = 'Percentual de Multa';
export const TIPO_DESCONTO = 'Tipo de Desconto';
export const DESCONTO = 'Desconto';
